import TagManager from 'react-gtm-module';

import translationEN from '../assets/translations/en.json';
import translationNL from '../assets/translations/nl.json';

const translations = {
  en: translationEN,
  nl: translationNL,
};
const browserLanguage: string = navigator?.language?.split('-')[0];
const lng: string = Object.prototype.hasOwnProperty.call(translations, browserLanguage) ? browserLanguage : 'en';

export const setupGTM = () => {
  if (window.tz_globalConfigs.gtmId) {
    TagManager.initialize({
      gtmId: window.tz_globalConfigs.gtmId,
      dataLayer: {
        event: 'page_load',
        app_platform: 'web',
        website_id: window.tz_globalConfigs.name,
        page_layout: window.matchMedia('(min-width: 1241px)').matches ? 'desktop' : 'mobile',
        customer: {
          store_language: lng,
        },
      },
    });
  }
};
